var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ion-app',[_c('ion-split-pane',{attrs:{"content-id":"page-content"}},[_c('BvaNavMenu'),_c('div',{attrs:{"id":"page-content"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }